/**
 * Misc UI element variables
 */
const articleContentMaxWidth = 680;
const siteMaxWidth = 1280;
const siteInnerMaxWidth = 960;
const siteGutter = 15;
const postSidebarWidth = 300;
const postSidebarGutter = 75;
const contentMaxWidth = siteMaxWidth - postSidebarWidth -
  postSidebarGutter - (2 * siteGutter);
const bodyTextWidthRatio = 0.7;
const bodyTextFullbleedWidth = `${(1 / bodyTextWidthRatio) * 100}%`;
const focusOutlineStyle = '3px solid var(--focusOutline)';
const focusBorderRadius = '3px';
const itemSpacing = '30px';
const itemsPerRow = 2;

module.exports = {
  '--articleContentMaxWidth': articleContentMaxWidth,
  '--bodyTextFullbleedWidth': bodyTextFullbleedWidth,
  '--bodyTextWidthRatio': bodyTextWidthRatio,
  '--condensedPickerHeight': 88,
  '--contentMaxWidth': contentMaxWidth,
  '--headerHeight': 134,
  '--postSidebarGutter': postSidebarGutter,
  '--postSidebarWidth': postSidebarWidth,
  '--shareButtonsBottomMargin': 20,
  '--shareButtonsHeight': 254,
  '--siteGutter': siteGutter,
  '--siteInnerMaxWidth': siteInnerMaxWidth,
  '--siteMaxWidth': siteMaxWidth,
  '--focusOutlineStyle': focusOutlineStyle,
  '--focusBorderRadius': focusBorderRadius,
  '--itemSpacing': itemSpacing,
  '--itemsPerRow': itemsPerRow,
};
